import React, { Component, Fragment } from 'react';
import MasterFileComparator from './MasterFileComparator.js';
import { withApi } from '../Providers/WebServiceProvider.js';
import MasterStringsService from '../Services/MasterStringsService.js';
import Swal from 'sweetalert2';

class MasterFileUploader extends Component {
  constructor (props) {
    super(props);

    this.state = {
      file: null,
      isBusy: false,
      differences: []
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.uploader = new MasterStringsService(props.webServiceContext.getApi());
  }

  onChange (e) {
    this.setState({ file: e.target.files[0] });
  }

  onSubmit (e) {
    if (! this.state.file) {
      return;
    }

    this.uploadFile(this.state.file);
  }

  uploadFile (file) {
    const that = this;

    this.setState({ isBusy: true });
    Swal("", 'Comparing masters...', 'info');
    this.uploader.compare(file).then(function (response) {
      Swal.close();
      that.setState({ differences: response.data.data.differences });
    });
  }

  render () {
    const that = this;

    return (
      <Fragment>
        <div className="title">
          <span className="title-content">
            <h1>Upload Master File</h1>
          </span>
        </div>
        <form>
          <div className="content" style={{textAlign: 'center'}}>
            <input id="upload" ref="upload" type="file" accept=".json" onChange={this.onChange} />
            { this.state.differences && Object.keys(this.state.differences).length > 0 && 
              <MasterFileComparator differences={that.state.differences} />
            }
          </div>
          <div className="bottom">
            <div className="level">
              <div className="level-left">
              </div>
              <div className="level-right">
                <span className="level-item">
                  <input type="button" className="button is-primary is-gradient" onClick={this.onSubmit} value="Upload" disabled={this.state.isBusy || !this.state.file} />
                </span>
              </div>
            </div>
          </div>
        </form>
      </Fragment>
    );
  }
}

export default withApi(MasterFileUploader);


// WEBPACK FOOTER //
// ./src/Components/MasterFileUploader.js